<template>
  <div>
    <v-overlay z-index="2" :value="edit">
      
    </v-overlay>
    <v-container
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="12" style="padding:8px 8px 0px 8px">
          <v-row>
            <v-col cols="8" xs="12">
              <Navigation
                :type="'Strategies'"
                :myOwn="myOwn"
                :username="user.username"
                :avatar="user.avatar"
              />
            </v-col>
            <v-col cols="4" xs="12">
              <div class="float-right">
                <v-btn v-if="myOwn" @click="addNew" icon class="my-0">
                  <v-icon size="18" color="#808F9C">add_circle_outline</v-icon>
                </v-btn>
                <v-btn v-if="myOwn" @click="editMethod" icon class="my-0" style="z-index:3">
                  <v-icon size="18" color="#808F9C">edit</v-icon>
                </v-btn>
                <v-btn icon class="my-0">
                  <v-icon size="18" color="#808F9C">filter_list</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col v-if="myOwn" xl="3" lg="3" md="4" sm="6" xs="12">
          <v-card flat style="min-height:170px;">
            <AddCard @newStrategy="pushNew" :addExternal="addIndex"/>
          </v-card>
        </v-col>

        <v-col xl="3" lg="3" md="4" sm="6" xs="12" v-if="!loaded && !myOwn" cols="3">
          <v-skeleton-loader ref="skeleton" type="image" max-height="180"></v-skeleton-loader>
        </v-col>
        <v-col xl="3" lg="3" md="4" sm="6" xs="12" v-if="!loaded" cols="3">
          <v-skeleton-loader ref="skeleton" type="image" max-height="180"></v-skeleton-loader>
        </v-col>
        <v-col xl="3" lg="3" md="4" sm="6" xs="12" v-if="!loaded" cols="3">
          <v-skeleton-loader ref="skeleton" type="image" max-height="180"></v-skeleton-loader>
        </v-col>
        <v-col xl="3" lg="3" md="4" sm="6" xs="12" v-if="!loaded" cols="3">
          <v-skeleton-loader ref="skeleton" type="image" max-height="180"></v-skeleton-loader>
        </v-col>

        <v-col
          xl="3"
          lg="3"
          md="4"
          sm="6"
          xs="12"
          v-for="(strategy,index) in strategies"
          :key="strategy._id"
        >
          <v-card flat style="min-height:170px;z-index:3;">
            <div class="">
              <div v-if="edit" class="delete-icon float-right">
                <v-btn @click="deleteStrategyMethod(strategy,index)" icon class="my-0">
                  <v-icon size="18" color="#808F9C">cancel</v-icon>
                </v-btn>
              </div>
            </div>
            <StrategyCard :record="strategy" :edit="edit" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteStrategyDialog"  max-width="500px">
      <v-card :loading="deleteStrategyLoading">
        <v-card-title>
          <span class="headline">Delete strategy <span class="text-green">{{deleteStrategyName}}</span> ?</span>
        </v-card-title>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteStrategyDialog = false">No</v-btn>
          <v-btn color="blue darken-1" text @click="deleteStrategyConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Navigation from "@/components/navigation.vue";
import StrategyCard from "./item.vue";
import AddCard from "./add.vue";
export default {
  name: "StrategyUser",

  components: { Navigation, StrategyCard, AddCard },

  data() {
    return {
      edit: false,
      countdownEdit: null,
      myOwn: false,
      loaded: false,
      deleteStrategyDialog: false,
      deleteStrategyLoading: false,
      deleteStrategyName: null,
      deleteStrategyID: null,
      deleteStrategyIndex: null,
      addIndex: 0
    };
  },

  created() {
    if (this.username == this.$route.params.name) {
      this.myOwn = true;
    }
  },

  asyncComputed: {
    strategies: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/strategies/", {
              method: "basic",
              user: this.$route.params.name
            })
            .then(response => {
              // setTimeout(() => {
              this.loaded = true;
              resolve(response.data);
              // },1000)
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: []
    },

    user: {
      get() {
        //if (this.username != this.$route.params.name) {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/user/", {
              method: "basic",
              name: this.$route.params.name
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
        //}
      },
      default: { username: "user", avatar: null }
    }
  },

  computed: {
    ...mapGetters(["username", "timezone"])
  },

  methods: {
    addNew(){
      this.addIndex++
    },
    editMethod(){
      if(this.edit){
        clearTimeout(this.countdownEdit);
        this.edit = false
      }else{
        this.edit = true
        this.countdownEdit = setTimeout(() => {
        this.edit = false;
        }, 8000);
      }
    },
    deleteStrategyMethod(strategy,index){
      clearTimeout(this.countdownEdit);
      this.deleteStrategyName = strategy.name
      this.deleteStrategyID = strategy._id
      this.deleteStrategyIndex = index
      this.deleteStrategyDialog = true
    },
    deleteStrategyConfirm(){
      this.deleteStrategyLoading = true
      axios
            .post("https://tradeinpool.com:3001/api/remove/strategies/", {
              method: "soft",
              id: this.deleteStrategyID
            })
            .then(response => {
              if(response.data){
                this.strategies.splice(this.deleteStrategyIndex, 1);
              }
              this.deleteStrategyDialog = false
              this.deleteStrategyLoading = false
            })
            .catch(err => {
              alert(err)
              this.deleteStrategyLoading = false
            });
    },
    pushNew(data) {
      this.strategies.unshift(data);
    }
  }
};
</script>

<style scoped>
.stat-value {
  font-size: 35px;
  height: 50px;
  margin-top: 10px;
}

.stat-name {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  color: #b6c1cb;
  margin-bottom: 10px;
}

.arrow-back {
  top: 0px;
  position: absolute;
  left: -100px;
  padding-top: 5px;
  text-align: center;
  height: 60px;
  width: 60px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: 0.5s;
  cursor: pointer;
}
.arrow-back-show {
  left: 0px;
}
.arrow-back:hover {
  text-align: left;
}
.title-move {
  margin-left: 60px;
}
.trans {
  transition: 0.5s;
}
.v-expansion-panels {
  background-color: white !important;
}

.myChip {
  float: left;
  background: #4dbac0 !important;
  width: auto;
  height: 34px;
  font-size: 24px;
  border-radius: 17px;
}

.min-flexheight {
  min-height: 250px;
}
</style>